import { render, staticRenderFns } from "./HomeIndex.vue?vue&type=template&id=61d70596&scoped=true"
import script from "./HomeIndex.vue?vue&type=script&lang=js"
export * from "./HomeIndex.vue?vue&type=script&lang=js"
import style0 from "./assets/index.css?vue&type=style&index=0&id=61d70596&prod&scoped=true&lang=css&external"
import style1 from "../assets/common.css?vue&type=style&index=1&id=61d70596&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d70596",
  null
  
)

export default component.exports